export const removeAuthTokens = () => {
  localStorage.removeItem("auth.RefreshToken")
  localStorage.removeItem("auth.AccessToken")
  localStorage.removeItem("user.Info")
}

export const addAuthTokens = (data: any) => {
  localStorage.setItem("auth.AccessToken", data.access)
  localStorage.setItem("auth.RefreshToken", data.refresh)
  localStorage.setItem("user.Info", JSON.stringify(data.user))
}
